import React from 'react'
import { Link, NavLink } from 'react-router-dom'
import { Stack, TableCell, TableRow } from '@mui/material'
import { formatBigMoney } from '../../../../packages/utils/numberFormatters'
import { formatWarrantSubPrice } from '../../../../components/entities/WarrantSubPrice'
import { HasWarrantLabel } from '../../../../components/entities/IssueTypeLabels'
import { WarrantEntity } from 'types/WarrantEntity'
import { getAmountForPriceAtDate, hasSubPeriodPrelPrice } from '../../../../utils/warrants'
import { normalizedWarrantName } from '@finance-lab/utils/shared'

type WarrantObject = {
    type: 'issue'
    subStartDate: string
    subEndDate: string
    item: WarrantEntity
}

export const WarrantTableRow = ({
    obj,
    locale,
    isLargeScreen,
    multipleInstrumentsExists = false,
}: {
    obj: WarrantObject
    locale: string
    isLargeScreen: boolean
    multipleInstrumentsExists: boolean
}) => {
    const warrant = obj.item

    const missingLabelIfNull = (value: string) => (value ? value : 'Saknas')
    const period =
        obj.subStartDate && obj.subEndDate
            ? `${missingLabelIfNull(obj.subStartDate)} - ${missingLabelIfNull(obj.subEndDate)}`
            : 'Saknas'

    const { subscriptionPeriods, totalNumberOfWarrants } = warrant

    const { warrantSubPrice, prelSubPrice, subStartDate } = warrant.currentSubscriptionPeriod
    const showPrelPrice = hasSubPeriodPrelPrice(warrant.currentSubscriptionPeriod)
    const price = showPrelPrice ? prelSubPrice : warrantSubPrice
    const amount =
        subStartDate === null
            ? null
            : getAmountForPriceAtDate(
                  price,
                  totalNumberOfWarrants,
                  subscriptionPeriods,
                  new Date(subStartDate).toISOString(),
              )
    return (
        <TableRow>
            {multipleInstrumentsExists && isLargeScreen ? <TableCell>{warrant.instrumentSymbol}</TableCell> : null}
            <TableCell>
                <Stack
                    direction={{ sx: 'column', sm: 'row' }}
                    spacing={2}
                    sx={{
                        alignItems: { xs: 'start', sm: 'center' },
                    }}
                >
                    <HasWarrantLabel />
                    <Link component={NavLink} to={`/warrants/${warrant.id}`}>
                        {normalizedWarrantName(warrant)}
                    </Link>
                </Stack>
            </TableCell>
            <TableCell>{period}</TableCell>
            <TableCell>{formatWarrantSubPrice(warrant, locale)}</TableCell>
            {isLargeScreen ? (
                <TableCell>
                    <>
                        {amount
                            ? formatBigMoney(amount, {
                                  currencySymbol: warrant.currency,
                                  decimals: 0,
                                  locale,
                                  tooltip: true,
                              })
                            : '-'}
                        {showPrelPrice && '*'}
                    </>
                </TableCell>
            ) : null}
        </TableRow>
    )
}
